<template>
  <div id="container">
    <div v-if="dataReady">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">

          <vx-card class="m-2">
            <div class="text-center">
              <h4>TOTAL LINE ITEM <span class="text-primary">[RESB]</span></h4>
            </div>
            <div class="flex flex-col md:flex-row">
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="CS" :value="resbTotalCS" />
              </div>
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="OS" :value="resbTotalOS" />
              </div>
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="TOTAL" :value="resbTotalCS + resbTotalOS" />
              </div>
            </div>

          </vx-card>

          <vx-card class="m-2">
            <div class="text-center">
              <h4>TOTAL STOCK BALANCE <span class="text-primary">[RESB]</span></h4>
            </div>
            <div class="flex flex-col md:flex-row">
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="CS" :value="resbTotalStockCS" />
              </div>
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="OS" :value="resbTotalStockOS" />
              </div>
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="TOTAL" :value="resbTotalStockCS + resbTotalStockOS" />
              </div>
            </div>

          </vx-card>

        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">

          <vx-card class="m-2">
            <div class="text-center">
              <h4>TOTAL LINE ITEM <span class="text-primary">[REEM]</span></h4>
            </div>
            <div class="flex flex-col md:flex-row">
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="CS" :value="reemTotalCS" />
              </div>
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="OS" :value="reemTotalOS" />
              </div>
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="TOTAL" :value="reemTotalCS + reemTotalOS" />
              </div>
            </div>

          </vx-card>

          <vx-card class="m-2">
            <div class="text-center">
              <h4>TOTAL STOCK BALANCE <span class="text-primary">[REEM]</span></h4>
            </div>
            <div class="flex flex-col md:flex-row">
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="CS" :value="reemTotalStockCS" />
              </div>
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="OS" :value="reemTotalStockOS" />
              </div>
              <div class="w-full md:w-1/2 bg-gray-100">
                <info label="TOTAL" :value="reemTotalStockCS + reemTotalStockOS" />
              </div>
            </div>

          </vx-card>

        </vs-col>
      </vs-row>
      <vs-row vs-w="12" vs-type="flex" vs-justify="center" class=" m-1">
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Line Item by Gasket Type"
            class="m-2 vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler donutTitle="CS" :dasbhboardData="resbCSLineItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Line Item by Gasket Type"
            class=" vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler donutTitle="OS" :dasbhboardData="resbOSLineItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Line Item by Gasket Type"
            class=" vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler donutTitle="CS" :dasbhboardData="reemCSLineItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Line Item by Gasket Type"
            class=" vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler donutTitle="OS" :dasbhboardData="reemOSLineItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" vs-type="flex" vs-justify="center" class=" m-1">
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Stock Balance by Gasket Type"
            class="m-2 vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler donutTitle="CS" :dasbhboardData="resbCSStockBalItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Stock Balance by Gasket Type"
            class="m-2 vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler donutTitle="OS" :dasbhboardData="resbOSStockBalItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Stock Balance by Gasket Type"
            class="m-2 vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler donutTitle="CS" :dasbhboardData="reemCSStockBalItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;&nbsp;&nbsp;
        </vs-col>
        <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
          <vx-card title="Stock Balance by Gasket Type"
            class="m-2 vx-col flex items-center justify-center flex-col   mx-auto text-center">
            <donutHandler donutTitle="OS" :dasbhboardData="reemOSStockBalItem"></donutHandler>
          </vx-card>&nbsp;&nbsp;&nbsp;&nbsp;
        </vs-col>

      </vs-row>
    </div>


  </div>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import donutHandler from './donutHandler.vue'
import info from './info.vue'
export default {
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    donutHandler,
    info
  },
  data() {
    return {
      resbCSLineItem: {},
      resbOSLineItem: {},
      reemCSLineItem: {},
      reemOSLineItem: {},
      reemCSStockBalItem: {},
      resbOSStockBalItem: {},
      resbCSStockBalItem: {},
      resbTotalCS: 0,
      resbTotalOS: 0,
      resbTotalStockCS: 0,
      resbTotalStockOS: 0,
      reemTotalCS: 0,
      reemTotalOS: 0,
      reemTotalStockCS: 0,
      reemTotalStockOS: 0,
      dataReady: false,
    };
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getData() {
      this.startLoading();
      this.aronPost('getStockMovementDashboard', {}, '', '')
        .then(response => {
          if (response.status) {
            this.resbCSLineItem = response.data.resbCSLineItem;
            this.resbOSLineItem = response.data.resbOSLineItem;
            this.reemCSLineItem = response.data.reemCSLineItem;
            this.reemOSLineItem = response.data.reemOSLineItem;

            this.resbCSStockBalItem = response.data.resbCSStockBalItem;
            this.resbOSStockBalItem = response.data.resbOSStockBalItem;
            this.reemCSStockBalItem = response.data.reemCSStockBalItem;
            this.reemOSStockBalItem = response.data.reemOSStockBalItem;

            this.resbTotalCS = response.data.resbTotalCS;
            this.resbTotalOS = response.data.resbTotalOS;
            this.resbTotalStockCS = response.data.resbTotalStockCS;
            this.resbTotalStockOS = response.data.resbTotalStockOS;

            this.reemTotalCS = response.data.reemTotalCS;
            this.reemTotalOS = response.data.reemTotalOS;
            this.reemTotalStockCS = response.data.reemTotalStockCS;
            this.reemTotalStockOS = response.data.reemTotalStockOS;
          } else {
            this.errorAlert('Error', response.data.error)
          }
          this.dataReady = true;
          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })

    }

  },
  mounted() {
    this.dataReady = false;
    this.getData();
  },
  created() {

  }
};
</script>
